import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Ticker } from '@pixi/ticker';
import gsap from 'gsap';

import { Shared } from '../App';

export class PointingArrow extends Container
{
    protected sprite: Sprite;

    constructor()
    {
        super();

        this.sprite = new Sprite(Shared.assets.getTexture('icon-updown-arrow'));
        this.sprite.anchor.set(0.5);
        this.sprite.scale.set(1.25);
        this.addChild(this.sprite);
        this.alpha = 0;
        this.visible = false;
    }

    public updateTransform(): void
    {
        super.updateTransform();
        this.sprite.y = Math.sin(Ticker.system.lastTime * 0.01) * 10;
    }

    public async show(): Promise<void>
    {
        gsap.killTweensOf(this);
        this.alpha = 0;
        this.visible = true;
        this.updateTransform();
        await gsap.to(this, { alpha: 1, duration: 0.2, ease: 'linear' });
    }

    public async hide(): Promise<void>
    {
        gsap.killTweensOf(this);
        await gsap.to(this, { alpha: 0, duration: 0.2, ease: 'linear' });
        this.alpha = 0;
        this.visible = false;
    }
}
